// @ts-check
'use_strict';
import { load_js_async } from '../tv_utils/utils.js';

/** Gloabal variable from Google Recaptcha library. */
declare var grecaptcha;

const recaptcha_url = 'https://www.google.com/recaptcha/api.js?render=explicit';

/**
 * Function to render or reset the given Google Recaptcha.
 */
function render_grecaptcha(recaptcha_element: HTMLElement) {
    // Google Recaptcha has already been rendered.
    if (recaptcha_element.childElementCount > 0) {
        // Find the Recaptcha response to add the necessary CSS class for validation.
        const recaptcha_response = recaptcha_element.querySelector('.g-recaptcha-response');
        recaptcha_response.classList.add('tv-recaptcha__response-required');
    } else {
        // Have to wait for the Recaptcha to render.
        const google_observer = new MutationObserver(() => {
            // Find the Recaptcha response to add the necessary CSS class for validation.
            const recaptcha_response = recaptcha_element.querySelector('.g-recaptcha-response');
            recaptcha_response.classList.add('tv-recaptcha__response-required');
            google_observer.disconnect();
        });
        google_observer.observe(recaptcha_element, { childList: true });

        // Render Google Recaptcha.
        const widget_id = grecaptcha.render(recaptcha_element, { 'sitekey': recaptcha_element.dataset.sitekey });
        // Set widget ID.
        recaptcha_element.setAttribute('id', widget_id);
    }
}

/**
 * This function is to initialize our Google Recaptcha styling changes to allow Recaptcha validation.
 * If no element is given, then all available Recaptcha elements are found and rendered.
 *
 * @param {HTMLElement|null} recaptcha_element is the element provided to get rendered or reset.
 * @return {void}
 */
export async function init_g_recaptcha(recaptcha_element: HTMLElement = null): Promise<void> {
    let recaptcha_elements = null;
    if (!recaptcha_element) {
        recaptcha_elements = <HTMLCollectionOf<HTMLElement>>document.getElementsByClassName('g-recaptcha');
        if (!recaptcha_elements.length) {
            return;
        }
    }
    if (typeof grecaptcha === 'undefined') {
        if (!await load_js_async(recaptcha_url)) {
            return;
        }
    }
    // If Google Recaptcha exists, then when it's ready we render it.
    grecaptcha.ready(() => {
        if (!recaptcha_element) {
            for (const recaptcha_element of recaptcha_elements) {
                render_grecaptcha(recaptcha_element);
            }
        } else {
            render_grecaptcha(recaptcha_element);
        }
    });
}
